import CivilizationModifiers from "../../model/CivilizationModifiers";
import CivilizationsEnum from "../CivilizationsEnum";
import ProductionSpeedModifierId from "../production-speed-modifiers/ProductionSpeedModifierId";
import {
    chineseDocks,
    foodImperialOfficial,
    goldImperialOfficial,
    granary,
    pagoda,
    stoneImperialOfficial,
    woodImperialOfficial
} from "./ChineseModifiers";
import GatheringRateModifierId from "../gathering-rate-modifiers/GatheringRateModifierId";
import UnitCostModifier from "../../model/UnitCostModifier";
import CostModifierId from "../cost-modifiers/CostModifierId";
import PassiveIncomeModifierId from "../passive-income-modifiers/PassiveIncomeModifierId";
import PassiveIncomeSource from "../passive-income-modifiers/PassiveIncomeSource";
import ResourceDropOffModifierId from "../resource-drop-off-modifiers/ResourceDropOffModifierId";

const zhuXisLegacyYuanDynasty: UnitCostModifier = {
    id: CostModifierId.ZHU_XIS_LEGACY_YUAN_DYNASTY,
    canBeApplied: () => true,
    apply: currentCost => ({
        food: currentCost.food * 0.9,
        wood: currentCost.wood * 0.9,
        gold: currentCost.gold * 0.9,
        stone: currentCost.stone * 0.9,
    }),
    description: 'unitCost * 0.9'
};

const ZHU_XI_GATHERING_RATE_MODIFIERS = {
    [GatheringRateModifierId.GRANARY]: granary
}

const ZHU_XI_PRODUCTION_SPEED_MODIFIERS = {
    [ProductionSpeedModifierId.CHINESE_DOCKS]: chineseDocks
};

const ZHU_XI_COST_MODIFIERS = {
    [CostModifierId.ZHU_XIS_LEGACY_YUAN_DYNASTY]: zhuXisLegacyYuanDynasty
};

const ZHU_XI_PASSIVE_INCOME_MODIFIERS = {
    [PassiveIncomeModifierId.PAGODA]: pagoda,
};

const ZHU_XI_PASSIVE_INCOME_SOURCES = [
    PassiveIncomeSource.PAGODA,
];

const DEFAULT_PASSIVE_INCOME_MODIFIERS = [
    PassiveIncomeModifierId.PAGODA,
];

const ZHU_XI_RESOURCE_DROP_OFF_MODIFIERS = {
    [ResourceDropOffModifierId.FOOD_IMPERIAL_OFFICIAL]: foodImperialOfficial,
    [ResourceDropOffModifierId.WOOD_IMPERIAL_OFFICIAL]: woodImperialOfficial,
    [ResourceDropOffModifierId.GOLD_IMPERIAL_OFFICIAL]: goldImperialOfficial,
    [ResourceDropOffModifierId.STONE_IMPERIAL_OFFICIAL]: stoneImperialOfficial,
}

const ZHU_XIS_LEGACY_MODIFIERS: CivilizationModifiers = {
    civilization: CivilizationsEnum.ZHU_XIS_LEGACY,
    allGatheringRateModifiers: ZHU_XI_GATHERING_RATE_MODIFIERS,
    defaultGatheringRateModifiers: [],
    allProductionSpeedModifiers: ZHU_XI_PRODUCTION_SPEED_MODIFIERS,
    defaultProductionSpeedModifiers: [ProductionSpeedModifierId.CHINESE_DOCKS],
    allCostModifiers: ZHU_XI_COST_MODIFIERS,
    defaultCostModifiers: [],
    passiveIncomeSources: ZHU_XI_PASSIVE_INCOME_SOURCES,
    allPassiveIncomeModifiers: ZHU_XI_PASSIVE_INCOME_MODIFIERS,
    defaultPassiveIncomeModifiers: DEFAULT_PASSIVE_INCOME_MODIFIERS,
    allLimitedFoodGatheringSourceModifiers: {},
    allPassiveIncomeFromGatheringVillagerModifiers: {},
    allCostModifiersPerUnit: {},
    allResourceDropOffModifiers: ZHU_XI_RESOURCE_DROP_OFF_MODIFIERS
}

export default ZHU_XIS_LEGACY_MODIFIERS;